import { createContext, ReactNode, useContext } from 'react';

export const ModalAriaLabelledByContext = createContext<string | undefined>(undefined);

export function ModalAriaLabelledByProvider({ ariaLabelledBy, children }: { ariaLabelledBy: string; children: ReactNode }) {
  return <ModalAriaLabelledByContext.Provider value={ariaLabelledBy}>{children}</ModalAriaLabelledByContext.Provider>;
}

export function useModalAriaLabelledBy(): string {
  const id = useContext(ModalAriaLabelledByContext);
  if (!id) {
    throw new Error('useModalAriaLabelledBy must be used within ModalAriaLabelledByProvider');
  }
  return id;
}
